module.exports = __webpack_public_path__ + "img/minotaur.a1e6b5f2.png";